import { __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { NavController, IonicModule } from '@ionic/angular';
import { UiBsTranslateService, UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

let UICMenuAppService = class UICMenuAppService {
    constructor() {
        this.menuObservable = new Subject();
        this.menuStatus = true;
        // cria o subscribe
        this.menuObservable.subscribe({
            next: res => {
                this.menuStatus = res;
                // console.log("(2) Flag value on menuObservable subscribe: ", res)
                return this.menuStatus;
            }
        });
        this.colorObservable = new Subject();
        this.colorStatus = '';
        // cria o subscribe
        this.colorObservable.subscribe({
            next: res => {
                this.colorStatus = res;
                // console.log("(2) Flag value on menuObservable subscribe: ", res)
                return this.colorStatus;
            }
        });
    }
    applyStatus(flag) {
        // console.log("(1) Flag passed in applyStatus call: ",flag)
        this.menuObservable.next(flag);
    }
    getStatusObservable() {
        return this.menuObservable.asObservable();
    }
    applyIcon(flag) {
        // console.log("(1) Flag passed in applyStatus call: ",flag)
        this.colorObservable.next(flag);
    }
    getColorObservable() {
        return this.colorObservable.asObservable();
    }
};
UICMenuAppService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UICMenuAppService_Factory() { return new UICMenuAppService(); }, token: UICMenuAppService, providedIn: "root" });
UICMenuAppService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], UICMenuAppService);

let UICMenuAppComponent = class UICMenuAppComponent {
    constructor(service, router, navCrtl, translate) {
        this.service = service;
        this.router = router;
        this.navCrtl = navCrtl;
        this.translate = translate;
        /**
         * deve ser usado para informar qual o tipo de acao que o botao do meio ira executar.
         * @values link | action | submenu
         */
        this.middleButtonMode = 'submenu';
        /**
         * se o middleButtonMode for action, emitir este evento para o tema
         */
        this.middleButtonActionCall = new EventEmitter();
    }
    /**
     * aplica a estrutura de rotas do menu
     */
    set menuContent(content) {
        if (content !== undefined) {
            this.menuData = content;
            this.verifyItemMenuQrCode();
        }
    }
    /**
     * aplica a estrutura de rotas do menu base
     */
    set menuBaseContent(content) {
        if (content !== undefined) {
            this.menuBase = content;
            this.btnIcon = this.checkMainMenuicon();
        }
    }
    ngOnInit() {
        this.service.getStatusObservable().subscribe((res) => {
            this.menuStatus = res;
        });
        this.service.getColorObservable().subscribe((res) => {
            this.colorStatus = res;
        });
        this.btnIcon = this.checkMainMenuicon();
        this.showInitial = false;
        this.showSeccond = false;
        this.menuStatus = true;
        this.sliderPropperty = {
            slidesPerView: 2,
            initialState: 0,
        };
    }
    /**
     * checa se existe um icone aplicado na configuracao do menu (para o botao principal do menu)
     */
    checkMainMenuicon() {
        const icon = (this.menuBase.icon !== undefined) ? this.menuBase.icon : 'apps-outline';
        return icon;
    }
    /**
     * controle de acao para o botao principal do menu (botao do meio)
     */
    toggleMenu(status) {
        // caso o botao deve chamar o link
        if (this.middleButtonMode === 'link') {
            this.redirectUri(this.menuBase.link);
            return;
        }
        // caso o botao deve chamar um submenu
        if (this.middleButtonMode === 'submenu') {
            this.btnIcon = this.btnIcon === 'close-outline' ? this.checkMainMenuicon() : 'close-outline';
            this.showInitial = this.showInitial === false ? true : false;
            this.showSeccond = false;
            if (status) {
                this.showInitial = false;
                this.btnIcon = this.checkMainMenuicon();
            }
        }
        // caso o botao deva chamar alguma acao dentro do tema (customizado)
        if (this.middleButtonMode === 'action') {
            this.middleButtonActionCall.emit(true);
        }
    }
    /**
     * controle do segundo menu (azul)
     * @param index
     */
    toggleSeccondList(index) {
        this.cardContentArray = this.menuData[index].url;
        this.showSeccond = this.showSeccond === false ? true : false;
    }
    /**
     * deve ser chamado quando clicar em alguma opcao do segundo menu (azul)
     * @param router
     */
    seccondOptClick(router) {
        this.navCrtl.navigateRoot([router]);
        this.toggleMenu(); // fecha o menu
    }
    redirectUri(link) {
        const params = this.parseUrlParamsToObject(link);
        if (params) {
            const navigationExtras = {
                queryParams: params,
            };
            // Navigate to the login page with extras
            this.router.navigate([link.split('?')[0]], navigationExtras);
        }
        else {
            const url = (typeof link === 'string') ? [link] : link;
            this.router.navigate(url);
        }
        if (this.menuBase.link === undefined) {
            this.toggleMenu(true);
        }
    }
    parseUrlParamsToObject(url) {
        if (/\?/g.test(url)) {
            const hashes = url.slice(url.indexOf('?') + 1).split('&');
            return hashes.reduce((params, hash) => {
                const [key, val] = hash.split('=');
                return Object.assign(params, { [key]: decodeURIComponent(val) });
            }, {});
        }
        return false;
    }
    verifyItemMenuQrCode() {
        this.menuData.forEach(el => {
            if (el.label === 'MENU_APP.QR_CODE.TITLE') {
                let index = this.menuData.indexOf(el);
                console.log(index);
                this.menuData[index].label = this.translate.applyTranslate('MENU_APP.QR_CODE.TITLE', { wlName: this.wlName });
            }
        });
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UICMenuAppComponent.prototype, "middleButtonMode", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UICMenuAppComponent.prototype, "middleButtonActionCall", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UICMenuAppComponent.prototype, "wlName", void 0);
__decorate([
    Input('menuContent'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], UICMenuAppComponent.prototype, "menuContent", null);
__decorate([
    Input('menuBaseContent'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], UICMenuAppComponent.prototype, "menuBaseContent", null);
UICMenuAppComponent = __decorate([
    Component({
        selector: 'ui-c-menu-app',
        template: "<ng-container *ngIf=\"menuStatus\">\n  <ion-footer id=\"ui-menu-app-container\">\n    <!-- primeiro nivel -->\n    <ion-toolbar *ngIf=\"showInitial\" id=\"first-level-menu\">\n      <ion-slides #slider [options]=\"sliderPropperty\">\n        <ion-slide class=\"align-items-baseline\" *ngFor=\"let card of menuData; let i = index\">\n          <ng-container *ngIf=\"card?.type === 'menu'\">\n            <ion-card (click)=\"toggleSeccondList(i)\">\n              <ion-card-header>\n                <svg-icon class=\"image-icon\" [src]=\"card?.icon\"></svg-icon>\n                <h1>{{ card?.label | wlpTranslate }}</h1>\n              </ion-card-header>\n            </ion-card>\n          </ng-container>\n\n          <ng-container *ngIf=\"card?.type === 'link'\">\n            <ion-card (click)=\"seccondOptClick(card?.url)\">\n              <ion-card-header>\n                <svg-icon class=\"image-icon\" [src]=\"card?.icon\"></svg-icon>\n                <h1>{{ card?.label | wlpTranslate }}</h1>\n              </ion-card-header>\n            </ion-card>\n          </ng-container>\n        </ion-slide>\n      </ion-slides>\n    </ion-toolbar>\n    <!-- fim primeiro nivel -->\n\n    <!-- segundo nivel do menu -->\n    <ion-toolbar *ngIf=\"showSeccond\" id=\"seccond-level-menu\">\n      <ion-grid>\n        <!-- cria as op\u00E7\u00F5es no segundo nivel (4 opcoes) -->\n        <ion-row class=\"row\">\n          <ng-container *ngFor=\"let content of cardContentArray; let i = index\">\n            <ion-col *ngIf=\"i <= 1\" class=\"col\">\n              <div class=\"row\">\n                <ion-button class=\"col btn-option\" color=\"light\" (click)=\"seccondOptClick(content?.url)\">\n                  {{ content?.label | wlpTranslate }}\n                </ion-button>\n              </div>\n            </ion-col>\n          </ng-container>\n        </ion-row>\n        <!-- fim cria as op\u00E7\u00F5es no segundo nivel (4 opcoes) -->\n\n        <!-- cria as op\u00E7\u00F5es no segundo nivel (4 opcoes) -->\n        <ion-row class=\"row\">\n          <ng-container *ngFor=\"let content of cardContentArray; let i = index\">\n            <ion-col *ngIf=\"i > 1\" class=\"col\">\n              <div class=\"row\">\n                <ion-button class=\"col btn-option\" color=\"light\" (click)=\"seccondOptClick(content?.url)\">\n                  {{ content?.label | wlpTranslate }}\n                </ion-button>\n              </div>\n            </ion-col>\n          </ng-container>\n        </ion-row>\n        <!-- fim cria as op\u00E7\u00F5es no segundo nivel (4 opcoes) -->\n      </ion-grid>\n    </ion-toolbar>\n    <!-- fim segundo nivel-->\n\n    <!-- base menu-->\n    <ion-toolbar id=\"menu-base\">\n      <ion-buttons id=\"btn-menu-list row\">\n        <ng-container *ngFor=\"let base of menuBase?.url; let i = index\">\n\n          <ng-container *ngIf=\"i === 2\">\n            <!-- separator -->\n            <div class=\"col separator-col px-1\"></div>\n          </ng-container>\n\n\n          <!-- caso o botao tem uma label -->\n          <ng-container *ngIf=\"base?.label !== undefined\">\n            <ion-button (click)=\"redirectUri(base?.url)\" class=\"col px-0\">\n              <div class=\"ui-c-menu-base-button\">\n\n                <!-- custom icon -->\n                <ng-container *ngIf=\"base?.image !== undefined\">\n                  <img class=\"ion-icon mx-auto d-block\" [src]=\"base?.image\">\n                </ng-container>\n                \n                <!-- caso o icone for do ionic -->\n                <ng-container *ngIf=\"base?.icon !== undefined\">\n                  <ion-icon class=\"ion-icon\" *ngIf=\"base?.type !== 'src'\" [name]=\"base?.icon\"></ion-icon>\n                  <ion-icon class=\"ion-icon\" *ngIf=\"base?.type === 'src'\" [src]=\"base?.icon\" [ngClass]=\"colorStatus === base?.idColor ? 'selectedColor' : ''\" ></ion-icon>\n                </ng-container>\n                \n                <span class=\"text-center d-block mt-1 btn-icon-label\"  [ngClass]=\"colorStatus === base?.idColor ? 'selectedColor' : ''\">\n                  {{ base?.label | wlpTranslate }} \n                </span>\n              </div>\n            </ion-button>\n          </ng-container>\n          \n          <!-- caso o botao nao tem label -->\n          <ng-container *ngIf=\"base?.label === undefined\">\n            <ion-button (click)=\"redirectUri(base?.url)\" class=\"col\">\n              <!-- custom icon -->\n                <ng-container *ngIf=\"base?.image !== undefined\">\n                  <img class=\"ion-icon mx-auto d-block\" [src]=\"base?.image\">\n                </ng-container>\n                \n                <!-- caso o icone for do ionic -->\n                <ng-container *ngIf=\"base?.icon !== undefined\">\n                  <ion-icon class=\"ion-icon\" [name]=\"base?.icon\"></ion-icon>\n                </ng-container>\n            </ion-button>\n          </ng-container>\n\n        </ng-container>\n      </ion-buttons>\n    </ion-toolbar>\n  </ion-footer>\n  <!-- fim menu base -->\n\n  <!-- botao principal do menu -->\n  <ion-fab class=\"ui-menu-btn-menu\" vertical=\"bottom\" horizontal=\"center\" size=\"large\">\n    <ion-fab-button class=\"fab\"\n      [ngClass]=\"{ 'seccond-menu': showSeccond, 'first-menu': showInitial && showSeccond === false }\"\n      (click)=\"toggleMenu()\">\n      <ion-icon size=\"large\" [name]=\"btnIcon\"></ion-icon>\n    </ion-fab-button>\n  </ion-fab>\n</ng-container>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UICMenuAppService,
        Router,
        NavController,
        UiBsTranslateService])
], UICMenuAppComponent);

let UICMenuAppModule = class UICMenuAppModule {
};
UICMenuAppModule = __decorate([
    NgModule({
        declarations: [UICMenuAppComponent],
        providers: [UICMenuAppService],
        imports: [
            RouterModule,
            IonicModule,
            CommonModule,
            RouterModule,
            AngularSvgIconModule,
            UiBsTranslateModule,
        ],
        exports: [UICMenuAppComponent],
    })
], UICMenuAppModule);

export { UICMenuAppComponent, UICMenuAppModule, UICMenuAppService };
//# sourceMappingURL=wlp-ui-c-menu-app.js.map
